import React, { Fragment } from 'react';
import AddtionalSalesSummaryView from './AddtionalSalesSummaryView';

// Thin route entry — the V3 shell lives inside the view.
const AdditionalSalesSummary = () => (
    <Fragment>
        <AddtionalSalesSummaryView />
    </Fragment>
);

export default AdditionalSalesSummary;
